import React from 'react';

const UnknownPage = () => {
  return (<h1>404 Not Found.</h1>)
};

export default UnknownPage;
